/**
 * Персистентность фильтров отчётов в localStorage (на этом устройстве).
 *
 * Флаг «сохранять настройки фильтров в отчётах» переключается на странице
 * «Мои настройки» (/me/settings). Пока флаг включён, каждая поддерживающая
 * отчёт-страница (через usePersistedUrlState) запоминает свои фильтры и
 * восстанавливает их при следующем открытии — если только в ссылке не
 * переданы явные параметры (тогда уважаем ссылку и ничего не подменяем).
 *
 * Всё хранится локально в браузере: сами значения фильтров могут быть
 * объёмными и не имеют смысла на других устройствах, поэтому в БД их не
 * складываем (в отличие от, например, избранных отчётов). Сам флаг тоже
 * локальный — «помнить мои фильтры» это свойство конкретного браузера.
 */

const FLAG_KEY    = 'crm.reportFiltersPersist';  // '1' | '0'
const BLOB_PREFIX = 'crm.reportFilters.';        // + storageKey → JSON недефолтных полей

export function isReportFilterPersistEnabled() {
  try {
    return localStorage.getItem(FLAG_KEY) === '1';
  } catch {
    return false;
  }
}

export function setReportFilterPersistEnabled(on) {
  try {
    localStorage.setItem(FLAG_KEY, on ? '1' : '0');
    // При выключении забываем всё, что запомнили — «не помнить мои фильтры».
    if (!on) clearAllReportFilters();
  } catch {
    /* приватный режим / переполнение — тихо игнорируем */
  }
}

export function loadReportFilters(storageKey) {
  try {
    const raw = localStorage.getItem(BLOB_PREFIX + storageKey);
    if (!raw) return null;
    const val = JSON.parse(raw);
    return val && typeof val === 'object' ? val : null;
  } catch {
    return null;
  }
}

export function saveReportFilters(storageKey, obj) {
  try {
    if (obj && Object.keys(obj).length) {
      localStorage.setItem(BLOB_PREFIX + storageKey, JSON.stringify(obj));
    } else {
      // Нечего запоминать (всё по умолчанию) — не держим пустой блоб.
      localStorage.removeItem(BLOB_PREFIX + storageKey);
    }
  } catch {
    /* игнорируем */
  }
}

export function clearAllReportFilters() {
  try {
    const keys = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && k.startsWith(BLOB_PREFIX)) keys.push(k);
    }
    keys.forEach((k) => localStorage.removeItem(k));
  } catch {
    /* игнорируем */
  }
}
